export const PRODUCT_TYPE_CAR: ProductType = "car";
export const PRODUCT_TYPE_MOBILE: ProductType = "mobile";

export const PRODUCT_NAME_CAR = "cars";
export const PRODUCT_NAME_DEVICES = "devices";

// Optional: create a mapping if you often convert between them
export const PRODUCT_NAME: Record<ProductType, string> = {
	car: PRODUCT_NAME_CAR,
	mobile: PRODUCT_NAME_DEVICES,
};

export const PRODUCT_TYPE: Record<string, ProductType> = {
	[PRODUCT_NAME_CAR]: PRODUCT_TYPE_CAR,
	[PRODUCT_NAME_DEVICES]: PRODUCT_TYPE_MOBILE,
};
